import { signupSource } from "_constants";

export function parseQueryParams(searchParams = window.location.search) {
    const query = new URLSearchParams(searchParams);

    const signupOrigin = query.get("signup_origin") || undefined;
    const shop = query.get("shop") || undefined;
    const isShopify = signupOrigin?.toLowerCase() === signupSource.SHOPIFY.toLowerCase();

    return {
        isShopify,
        signupOrigin,
        shop: isShopify ? shop : undefined,
        email: query.get("email") || undefined,
        company: query.get("company") || undefined,
        firstName: query.get("first_name") || undefined,
        lastName: query.get("last_name") || undefined,
    };
}

export function buildLoginLink(searchParams = window.location.search) {
    if (!searchParams || searchParams === "?") return "/";
    const query = searchParams.startsWith("?") ? searchParams.slice(1) : searchParams;
    return `/shopify/connect-account?${query}`;
}
